import axios from 'axios'

axios.defaults.withCredentials = true

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.der-supertolle-quizabend.de/openapi' : 'http://192.168.178.63:3000/openapi';
// axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.der-supertolle-quizabend.de/openapi' : 'http://192.168.11.13:3000/openapi';
console.log('OPENAPI Axios base URL:', axios.defaults.baseURL)
const openapi = axios.create({withCredentials : true});

export default openapi;